import qs from 'qs';
import fetcher from '../modules/ajio-fetch';
import {
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  getErrorStatusCode,
  errorParser,
  loginHostUrl,
  getFetcherHeader
} from '../modules/ajio-fetch/utils';
import { readCookie } from '../utils/Cookie';
import properties from '../modules/ajio-util/properties';
import endpoints from '../modules/ajio-util/endpoints';
import isNode from '../modules/ajio-util/isNode';
const login_url = properties.getProperty('loginPageURL');
export function createAnonymousToken(req = {}) {
  return new Promise((resolve, reject) => {
    createAnonymousLogin(req)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}
export function createTokenWithRefreshToken(req = {}) {
  return new Promise((resolve, reject) => {
    setAccessToken(req)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}
export function createAnonymousLogin(req = {}) {
  const fp = readCookie('_fpuuid');
  let apiPath = `${loginHostUrl(login_url, '/api/auth/login')}?fp=${fp}`;
  if (!login_url && Object.keys(req).length) {
    const { headers: { host = '' } = {} } = req;
    apiPath = `http://${host}${apiPath}`;
  }
  return new Promise((resolve, reject) => {
    fetcher(
      apiPath,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ guestToken: true })
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const { serviceRes = {} } = response;
        if (req && req.cookies) {
          req.cookies.A = serviceRes.access_token;
          req.expires_in = serviceRes.expires_in;
        }
        resolve(serviceRes);
      })
      .catch(error => {
        reject(error);
      });
  });
}
export function setAccessToken(req) {
  const R = req.cookies && req.cookies.R;
  const refreshToken = R || req.refreshToken;
  if (!refreshToken) {
    return Promise.reject({});
  }
  const body = {
    refreshToken
  };
  const apiEndPoint = loginHostUrl(login_url, '/api/auth/get-access-token');
  return new Promise((resolve, reject) => {
    fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(body)
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}
export function setToken(token) {
  return {
    type: 'SET_TOKEN',
    token
  };
}
export function createAnonymousLoginAtNode(req = {}) {
  if (isNode()) {
    const clientConfiguration = Object.freeze({
      id: 'web_client',
      secret: 'secret'
    });
    const requestBody = {
      client_id: clientConfiguration.id,
      client_secret: clientConfiguration.secret,
      grant_type: 'client_credentials'
    };
    const {
      device: { client_type: clientType = '' } = {},
      cookies: { _fpuuid: fingerprint = '' } = {}
    } = req;
    const headerInfo = getFetcherHeader(req);
    const apiEndPointUrl = fingerprint
      ? `${endpoints.get('loginToken')}?client_type=${clientType}&browserFingerprint=${fingerprint}`
      : `${endpoints.get('loginToken')}?client_type=${clientType}`;
    return new Promise((resolve, reject) => {
      fetcher(
        apiEndPointUrl,
        fetchGetJSONReqOpts({
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            ...headerInfo
          },
          method: 'POST',
          body: qs.stringify(requestBody)
        })
      )
        .then(fetchGetJSONResHandler)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  return createAnonymousToken(req);
}